module.exports = __webpack_public_path__ + "img/qh@2x.901cf050.png";